import React from 'react';
import PropTypes from 'prop-types';

import RichTextEditorToolbar from '../../../domains/richText/components/toolbar/RichTextEditorToolbar';
import presetNameList from '../../../domains/richText/config/presetNameList';

import styles from './HeaderTextEditorToolbar.scss';

const HeaderTextEditorToolbar = ({ id }) => (
  <div className={styles.tools}>
    <div className={styles.corner} />
    <RichTextEditorToolbar
      id={id}
      preset={presetNameList.header}
      className={styles.toolbar}
    />
  </div>
);

HeaderTextEditorToolbar.propTypes = {
  id: PropTypes.string.isRequired,
};

export default HeaderTextEditorToolbar;
